import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { Requisition } from '@core/requisitions-types';
import type { AssignedJob } from '@recruitee/requisitions-data';
import { AssignedJobsSelectors } from '@recruitee/requisitions-data';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class JobsPageDataService {
  public requisition$: Observable<Requisition>;
  public jobs$: Observable<AssignedJob[]>;
  public isLoaded$: Observable<boolean>;

  constructor(
    private rootData: RootPageDataService,
    private store: Store,
  ) {
    this.requisition$ = rootData.requisition$;
    const requisitionId$ = this.requisition$.pipe(map(requisition => requisition.id));
    this.jobs$ = requisitionId$
      .pipe(switchMap(id => store.select(AssignedJobsSelectors.byId(id))))
      .pipe(filterBoolean);
    this.isLoaded$ = requisitionId$.pipe(
      switchMap(id => store.select(AssignedJobsSelectors.isLoaded(id))),
    );
  }
}
